import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * "Xero not connected" notice for a list whose Xero actions are disabled until the company is
 * linked. Presentational only — the page owns the status call and passes the answer in.
 *
 * Nothing renders until `loaded` is true, so the banner never flashes on a connected company while
 * the status request is still in flight.
 */
@Component({
  selector: 'app-xero-banner',
  standalone: true,
  template: `
    @if (loaded && !connected) {
      <div class="xero-banner">
        <span class="xero-banner__badge">Xero not connected</span>
        <span class="xero-banner__hint">{{ hint }}</span>
      </div>
    }
  `,
  styleUrl: './xero-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XeroBannerComponent {
  /** The status call has landed. Until it has, the banner stays hidden. */
  @Input() loaded = false;

  /** Whether this company is linked to Xero. Connected → nothing renders. */
  @Input() connected = false;

  /** What is unavailable while disconnected, in the page's own words. */
  @Input({ required: true }) hint!: string;
}
